<ng-container *ngIf="!isLong">
  <span class="text-content">{{ displayText }}</span>
</ng-container>

<ng-container *ngIf="isLong">
  <!-- Inline / Both Mode -->
  <ng-container *ngIf="mode === 'inline' || mode === 'both'">
    <ng-container *ngIf="!isExpanded">
      <span class="text-content">{{ truncatedText }}...</span>
      <span class="actions-wrapper">
        <button type="button" class="expand-btn" (click)="toggleExpand($event)">
          <span>{{ showMoreText }}</span>
          <mat-icon class="expand-icon">expand_more</mat-icon>
        </button>
        <button *ngIf="mode === 'both'" type="button" class="modal-icon-btn" (click)="openModal($event)" [matTooltip]="viewFullDescriptionText">
          <mat-icon class="modal-icon">open_in_new</mat-icon>
        </button>
      </span>
    </ng-container>

    <div *ngIf="isExpanded" class="expanded-wrapper">
      <div class="text-content expanded-text">{{ displayText }}</div>
      <div class="expanded-actions">
        <button type="button" class="expand-btn collapse-btn" (click)="toggleExpand($event)">
          <span>{{ showLessText }}</span>
          <mat-icon class="expand-icon">expand_less</mat-icon>
        </button>
        <button *ngIf="mode === 'both'" type="button" class="modal-icon-btn" (click)="openModal($event)" [matTooltip]="viewFullDescriptionText">
          <mat-icon class="modal-icon">open_in_new</mat-icon>
        </button>
      </div>
    </div>
  </ng-container>

  <!-- Modal Only Mode -->
  <ng-container *ngIf="mode === 'modal'">
    <span class="text-content">{{ truncatedText }}...</span>
    <button type="button" class="expand-btn" (click)="openModal($event)">
      <span>{{ showMoreText }}</span>
      <mat-icon class="expand-icon">open_in_new</mat-icon>
    </button>
  </ng-container>
</ng-container>
